//idea validation is now called as ideavalidation test

import { useState, useContext, useEffect, useRef } from "react";
import "./IdeaValidationForms.css";
import { useNavigate} from "react-router-dom"; // ✅ IMPORT useParams
import { ThemeContext } from "./context/themeContext";
import { useAuth } from "./auth/useAuth";
import { useRequireAuth } from "./hooks/useRequireAuth";
import { apiFetch } from "./utils/apiFetch";
import { FaArrowLeftLong } from "react-icons/fa6";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";

const SECTOR_OPTIONS = [
  { value: "3D Printing", label: "3D Printing" },
  { value: "Accounting", label: "Accounting" },
  { value: "AdTech", label: "AdTech" },
  { value: "Advisory", label: "Advisory" },
  { value: "Agri-Tech", label: "Agri-Tech" },
  { value: "Agricultural Chemicals", label: "Agricultural Chemicals" },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Animal Husbandry", label: "Animal Husbandry" },
  { value: "Apparel", label: "Apparel" },
  { value: "Apparel & Accessories", label: "Apparel & Accessories" },
  { value: "Application Development", label: "Application Development" },
  { value: "Art", label: "Art" },
  { value: "Assistance Technology", label: "Assistance Technology" },
  { value: "Auto & Truck & Manufacturers", label: "Auto & Truck Manufacturers" },
  { value: "Auto Vehicles, Parts & Service Retailers", label: "Auto Vehicles, Parts & Service Retailers" },
  { value: "Auto, Truck & Motorcycle Parts", label: "Auto, Truck & Motorcycle Parts" },
  { value: "Aviation & Others", label: "Aviation & Others" },
  { value: "Baby Care", label: "Baby Care" },
  { value: "Big Data", label: "Big Data" },
  { value: "Billing and Invoicing", label: "Billing and Invoicing" },
  { value: "Biotechnology", label: "Biotechnology" },
  { value: "Bitcoin and Blockchain", label: "Bitcoin and Blockchain" },
  { value: "BPO", label: "BPO" },
  { value: "Branding", label: "Branding" },
  { value: "Business Finance", label: "Business Finance" },
  { value: "Business Intelligence", label: "Business Intelligence" },
  { value: "Business Support Services", label: "Business Support Services" },
  { value: "Business Support Supplies", label: "Business Support Supplies" },
  { value: "Clean Tech", label: "Clean Tech" },
  { value: "Clean Technology", label: "Clean Technology" },
  { value: "Cloud", label: "Cloud" },
  { value: "Coaching", label: "Coaching" },
  { value: "Collaboration", label: "Collaboration" },
  { value: "Commercial Printing Services", label: "Commercial Printing Services" },
  { value: "Commodity Chemicals", label: "Commodity Chemicals" },
  { value: "Comparison Shopping", label: "Comparison Shopping" },
  { value: "Computer & Electronics Retailers", label: "Computer & Electronics Retailers" },
  { value: "Construction & Engineering", label: "Construction & Engineering" },
  { value: "Construction Materials", label: "Construction Materials" },
  { value: "Construction Supplies & Fixtures", label: "Construction Supplies & Fixtures" },
  { value: "Consulting", label: "Consulting" },
  { value: "Corporate Social Responsibility", label: "Corporate Social Responsibility" },
  { value: "Coworking Spaces", label: "Coworking Spaces" },
  { value: "Crowdfunding", label: "Crowdfunding" },
  { value: "Customer Support", label: "Customer Support" },
  { value: "CXM", label: "CXM" },
  { value: "Cyber Security", label: "Cyber Security" },
  { value: "Dairy Farming", label: "Dairy Farming" },
  { value: "Data Science", label: "Data Science" },
  { value: "Defence Equipment", label: "Defence Equipment" },
  { value: "Digital Marketing (SEO Automation)", label: "Digital Marketing (SEO Automation)" },
  { value: "Digital Media", label: "Digital Media" },
  { value: "Digital Media Blogging", label: "Digital Media Blogging" },
  { value: "Digital Media News", label: "Digital Media News" },
  { value: "Digital Media Publishing", label: "Digital Media Publishing" },
  { value: "Digital Media Video", label: "Digital Media Video" },
  { value: "Discovery", label: "Discovery" },
  { value: "Diversified Chemicals", label: "Diversified Chemicals" },
  { value: "Drones", label: "Drones" },
  { value: "E-Commerce", label: "E-Commerce" },
  { value: "E-learning", label: "E-learning" },
  { value: "Education", label: "Education" },
  { value: "Education Technology", label: "Education Technology" },
  { value: "Electric Vehicles", label: "Electric Vehicles" },
  { value: "Electronics", label: "Electronics" },
  { value: "Embedded", label: "Embedded" },
  { value: "Employment Services", label: "Employment Services" },
  { value: "Enterprise Mobility", label: "Enterprise Mobility" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "Environmental Services & Equipment", label: "Environmental Services & Equipment" },
  { value: "ERP", label: "ERP" },
  { value: "Event Management", label: "Event Management" },
  { value: "Experiential Travel", label: "Experiential Travel" },
  { value: "Facility Management", label: "Facility Management" },
  { value: "Fan Merchandise", label: "Fan Merchandise" },
  { value: "Fantasy Sports", label: "Fantasy Sports" },
  { value: "Fashion Technology", label: "Fashion Technology" },
  { value: "Fisheries", label: "Fisheries" },
  { value: "Food & Beverage", label: "Food and Beverage" },
  { value: "Food Processing", label: "Food Processing" },
  { value: " Food Technology / Food Delivery", label: "Food Technology / Food Delivery" },
  { value: "Foreign Exchange", label: "Foreign Exchange" },
  { value: "Freight & Logistics Services", label: "Freight & Logistics Services" },
  { value: "Handicraft", label: "Handicraft" },
  { value: "Health & Wellness", label: "Health & Wellness" },
  { value: "Healthcare IT", label: "Healthcare IT" },
  { value: "Healthcare Services", label: "Healthcare Services" },
  { value: "Healthcare Technology", label: "Healthcare Technology" },
  { value: "Holiday Rentals", label: "Holiday Rentals" },
  { value: "Home Care", label: "Home Care" },
  { value: "Home Furnishings Retailers", label: "Home Furnishings Retailers" },
  { value: " Home Improvement Products & Services Retailers", label: "Home Improvement Products & Services Retailers" },
  { value: " Home Security solutions", label: "Home Security solutions" },
  { value: "Homebuilding", label: "Homebuilding" },
  { value: "Horticulture", label: "Horticulture" },
  { value: "Hospitality", label: "Hospitality" },
  { value: "Hotel", label: "Hotel" },
  { value: "Housing", label: "Housing" },
  { value: "Industrial Design", label: "Industrial Design" },
  { value: "Insurance", label: "Insurance" },
  { value: "Integrated communication services", label: "Integrated communication services" },
  { value: "Internet / Web Services", label: "Internet / Web Services" },
  { value: "Internships", label: "Internships" },
  { value: "IT Consulting", label: "IT Consulting" },
  { value: "IT Management", label: "IT Management" },
  { value: "IT Services", label: "IT Services" },
  { value: "Jewellery", label: "Jewellery" },
  { value: "KPO", label: "KPO" },
  { value: "Laundry", label: "Laundry" },
  { value: "Leather Footwear", label: "Leather Footwear" },
  { value: "Leather Textiles Goods", label: "Leather Textiles Goods" },
  { value: "Lifestyle", label: "Lifestyle" },
  { value: "Location Based", label: "Location Based" },
  { value: "Loyalty", label: "Loyalty" },
  { value: "Machine Learning", label: "Machine Learning" },
  { value: " Manufacture of Electrical Equipment", label: "Manufacture of Electrical Equipment" },
  { value: "Manufacture of Machinery and Equipment", label: "Manufacture of Machinery and Equipment" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Manufacturing & Warehouse", label: "Manufacturing & Warehouse" },
  { value: " Market Research", label: "Market Research" },
  { value: "Marketing / Advertising", label: "Marketing / Advertising" },
  { value: "Media and Entertainment", label: "Media and Entertainment" },
  { value: "Medical Devices Biomedical", label: "Medical Devices Biomedical" },
  { value: "Microbrewery", label: "Microbrewery" },
  { value: "Microfinance", label: "Microfinance" },
  { value: "Mobile", label: "Mobile" },
  { value: "Mobile wallet payments", label: "Mobile wallets Payments" },
  { value: "Movies", label: "Movies" },
  { value: "Natural Language Processing", label: "Natural Language Processing" },
  { value: "Network Technology Solutions", label: "Network Technology Solutions" },
  { value: "New-age Construction Technologies", label: "New-age Construction Technologies" },
  { value: "NGO", label: "NGO" },
  { value: "NLP", label: "NLP" },
  { value: "Non-Leather Footwear", label: "Non-Leather Footwear" },
  { value: "Non-Leather Textiles Goods", label: "Non-Leather Textiles Goods" },
  { value: "Oil & Gas Drilling", label: "Oil & Gas Drilling" },
  { value: "Oil & Gas Exploration and Production", label: "Oil & Gas Exploration and Production" },
  { value: "Oil & Gas Transportation Services", label: "Oil & Gas Transportation Services" },
  { value: "Oil Related Services and Equipment", label: "Oil Related Services and Equipment" },
  { value: "Online Classified", label: "Online Classified" },
  { value: "OOH Media", label: "OOH Media" },
  { value: "Organic Agriculture", label: "Organic Agriculture" },
  { value: "Others", label: "Others" },
  { value: "P2P Lending", label: "P2P Lending" },
  { value: "Passenger Transportation Services", label: "Passenger Transportation Services" },
  { value: "Payment Platforms", label: "Payment Platforms" },
  { value: "Personal Care", label: "Personal Care" },
  { value: "Personal Finance", label: "Personal Finance" },
  { value: "Personal Security", label: "Personal Security" },
  { value: "Pharmaceutical", label: "Pharmaceutical" },
  { value: "Photography", label: "Photography" },
  { value: "Physical Toys and Games", label: "Physical Toys and Games" },
  { value: "Point of Sales", label: "Point of Sales" },
  { value: "Product Development", label: "Product Development" },
  { value: "Professional Information Services", label: "Professional Information Services" },
  { value: "Project Management", label: "Project Management" },
  { value: "Public Citizen Security Solutions", label: "Public Citizen Security Solutions" },
  { value: "Recruitment Jobs", label: "Recruitment Jobs" },
  { value: "Renewable Energy Solutions", label: "Renewable Energy Solutions" },
  { value: "Renewable Nuclear Energy", label: "Renewable Nuclear Energy" },
  { value: "Renewable Solar Energy", label: "Renewable Solar Energy" },
  { value: "Renewable Wind Energy", label: "Renewable Wind Energy" },
  { value: "Restaurants", label: "Restaurants" },
  { value: "Retail Technology", label: "Retail Technology" },
  { value: "Robotics Application", label: "Robotics Application" },
  { value: "Robotics Technology", label: "Robotics Technology" },
  { value: "Sales", label: "Sales" },
  { value: "SCM", label: "SCM" },
  { value: "Semiconductor", label: "Semiconductor" },
  { value: "Skill Development", label: "Skill Development" },
  { value: "Skills Assessment", label: "Skills Assessment" },
  { value: "Smart Home", label: "Smart Home" },
  { value: "Social Commerce", label: "Social Commerce" },
  { value: "Social Media", label: "Social Media" },
  { value: "Space Technology", label: "Space Technology" },
  { value: "Specialty Chemicals", label: "Specialty Chemicals" },
  { value: "Sports Promotion and Networking", label: "Sports Promotion and Networking" },
  { value: "Talent Management", label: "Talent Management" },
  { value: "Telecommunications", label: "Telecommunications" },
  { value: "Testing", label: "Testing" },
  { value: "Ticketing", label: "Ticketing" },
  { value: "Tires & Rubber Products", label: "Tires & Rubber Products" },
  { value: "Trading", label: "Trading" },
  { value: "Traffic Management", label: "Traffic Management" },
  { value: "Training", label: "Training" },
  { value: "Transport Infrastructure", label: "Transport Infrastructure" },
  { value: "Transportation", label: "Transportation" },
  { value: "Utility Services", label: "Utility Services" },
  { value: "Virtual Games", label: "Virtual Games" },
  { value: "Waste Management", label: "Waste Management" },
  { value: "Wayside Amenities", label: "Wayside Amenities" },
  { value: "Wearables", label: "Wearables" },
  { value: "Web Design", label: "Web Design" },
  { value: "Web Development", label: "Web Development" },
  { value: "Weddings", label: "Weddings" },
  { value: "Wireless", label: "Wireless" },
  { value: "Advertising", label: "Advertising" },
  { value: " Aeronautics Aerospace & Defence", label: "Aeronautics Aerospace & Defence" },
  { value: "AI", label: "AI" },
  { value: "Airport Operations", label: "Airport Operations" },
  { value: "Analytics", label: "Analytics" },
  { value: "Animation", label: "Animation" },
  { value: "AR VR (Augmented + Virtual Reality)", label: "AR VR (Augmented + Virtual Reality)" },
  { value: "Architecture Interior Design", label: "Architecture Interior Design" },
  { value: "Art & Photography", label: "Art & Photography" },
  { value: "Automotive", label: "Automotive" },
  { value: "Biotechnology", label: "Biotechnology" },
  { value: "Chemicals", label: "Chemicals" },
  { value: "Computer Vision", label: "Computer Vision" },
  { value: "Construction", label: "Construction" },
  { value: "Dating Matrimonial", label: "Dating Matrimonial" },
  { value: "Design", label: "Design" },
  { value: "Enterprise Software", label: "Enterprise Software" },
  { value: "Events", label: "Events" },
  { value: "Fashion", label: "Fashion" },
  { value: "Finance Technology", label: "Finance Technology" },
  { value: "Food & Beverages", label: "Food & Beverages" },
  { value: "Green Technology", label: "Green Technology" },
  { value: "Healthcare & Lifesciences", label: "Healthcare & Lifesciences" },
  { value: "House-Hold Services", label: "House-Hold Services" },
  { value: "Human Resources", label: "Human Resources" },
  { value: "Indic Language Startups", label: "Indic Language Startups" },
  { value: "Internet of Things", label: "Internet of Things" },
  { value: "Logistics", label: "Logistics" },
  { value: "Marketing", label: "Marketing" },
  { value: "Media & Entertainment", label: "Media & Entertainment" },
  { value: "Nanotechnology", label: "Nanotechnology" },
  { value: "Non-Renewable Energy", label: "Non-Renewable Energy" },
  { value: "Other Specialty Retailers", label: "Other Specialty Retailers" },
  { value: "Passenger Experience", label: "Passenger Experience" },
  { value: "Pets & Animals", label: "Pets & Animals" },
  { value: "Professional & Commercial Services", label: "Professional & Commercial Services" },
  { value: ">Real Estate", label: "Real Estate" },
  { value: "Renewable Energy", label: "Renewable Energy" },
  { value: "Retail", label: "Retail" },
  { value: "Robotics", label: "Robotics" },
  { value: "Safety", label: "Safety" },
  { value: "Security Solutions", label: "Security Solutions" },
  { value: "Social Impact", label: "Social Impact" },
  { value: "Social Network", label: "Social Network" },
  { value: "Sports", label: "Sports" },
  { value: "Technology Hardware", label: "Technology Hardware" },
  { value: "Telecommunication & Networking", label: "Telecommunication & Networking" },
  { value: " Textiles & Apparel", label: "Textiles & Apparel" },
  { value: "Toys and Games", label: "Toys and Games" },
  { value: "Transportation & Storage", label: "Transportation & Storage" },
  { value: " Travel & Tourism", label: "Travel & Tourism" },
  { value: "Waste Management", label: "Waste Management" }
];

const getRequiredFieldsForStep = (step, stepData) => {
  switch (step) {
    case 0:
      return ["companyName", "fullName", "contact", "linkedin", "companyEmail", "ideaYears", "teamSize"];
    case 1:
      return ["sector", "incubationFocus", "ideaTitle", "ai", "applyIncubation"];
    case 2:
      return ["problem", "ideaDescription", "necessity", "offeringType", "painSegment", "businessModel"];
    case 3:
      return ["problemKind", "productMaturity"];
    case 4:
      return ["unfairAdvantage", "competition", "competitorStage", "coverageArea", "segmentation"];
    case 5:
      return ["cost", "profit", "financial", "price", "financingOptions"];
    case 6:
      return ["bestFitChannel", "pricingCurrency", "economic", "ecommerce"];
    case 7:
      return ["revenueStreams", "costStructure", "northStarMetric"];
    case 8:
      return ["team", "culture", "genderService", "deliveryMethod", "complaintsPercent", "available"];
    case 9:
      return ["adopt20", "legal", "marketing", "investorFit", "idea"];
    case 10: {
      const list = ["city", "stateName", "area", "coe"];
      if (stepData.area === "<Yes") {
        list.push("collaborationOrg");
      }
      return list;
    }
    default:
      return [];
  }
};

const STRONG_IDEA_DATA = {
  0: {
    companyName: "MarsMate BI Private Limited",
    fullName: "Sravan Kumar",
    contact: "9876543210",
    linkedin: "https://www.linkedin.com/in/sravankumar-marsmate",
    companyEmail: "marsmate.bi@gmail.com",
    ideaYears: "2024",
    website: "https://www.marsmateai.com",
    teamSize: "3"
  },
  1: {
    sector: "Enterprise Software",
    incubationFocus: "!Yes",
    ideaTitle: "MarsMate AI — AI-Powered Startup Idea Validation & Business Intelligence Platform",
    ai: "@Yes",
    applyIncubation: "Investments"
  },
  2: {
    problem: "Over 90% of early-stage startups fail because founders lack access to structured, data-driven idea validation. Professional consulting costs thousands of dollars and takes weeks, while free tools produce generic, unreliable results. Founders in India and emerging markets particularly suffer from this gap — they cannot afford institutional-grade market research, yet desperately need rigorous demand analysis, unit economics checks, and competitive intelligence before committing resources. This results in massive capital misallocation, wasted founder time, and investor losses at the seed stage. There is a clear, urgent market need for an affordable, automated, AI-powered idea validation platform that delivers professional intelligence in minutes.",
    ideaDescription: "MarsMate AI is a B2B SaaS platform that delivers institutional-grade startup idea validation at a fraction of traditional consulting costs. Founders complete an intelligent 11-step progressive form capturing business model details, market context, competitive landscape, and financial projections. The platform runs five validation layers: a 600-point deterministic scoring engine, an AI text quality scorer using Groq/Gemini LLMs, an internal consistency checker with 19 validation rules, a cross-answer coherence analyzer, and an automated report generator. Outputs include a comprehensive validation scorecard, a multi-page investor-ready PDF report, an AI business mentor, and a Go-To-Market roadmap. MarsMate targets incubators, accelerators, and university entrepreneurship cells as B2B clients, with individual founder subscriptions as B2C revenue.",
    necessity: "Market Need",
    offeringType: "Product",
    painSegment: "Companies",
    businessModel: "B2B"
  },
  3: {
    problemKind: "Unique Problem in oriented areas",
    productMaturity: "Scaling Stage"
  },
  4: {
    unfairAdvantage: "IP",
    competition: "#Yes",
    competitorStage: "Early Traction",
    coverageArea: "Country",
    segmentation: "$Yes"
  },
  5: {
    cost: "%Yes",
    profit: "^Yes",
    financial: "&Yes",
    price: "*Yes",
    financingOptions: "Installment Plans"
  },
  6: {
    bestFitChannel: "B2B Partnerships",
    pricingCurrency: "Local currency",
    economic: "(Yes",
    ecommerce: ")Yes"
  },
  7: {
    revenueStreams: "Subscription",
    costStructure: "Infra",
    northStarMetric: "Active Users"
  },
  8: {
    team: "-Yes",
    culture: "_Yes",
    genderService: "Others",
    deliveryMethod: "Digital",
    complaintsPercent: "10%",
    available: "+Yes"
  },
  9: {
    adopt20: "|Yes",
    legal: "}Yes",
    marketing: ":Yes",
    investorFit: "stage",
    idea: "{Yes"
  },
  10: {
    city: "Hyderabad",
    stateName: "Telangana",
    area: "<Yes",
    collaborationOrg: "Academia",
    coe: ">Yes"
  },
};

const WEAK_IDEA_DATA = {
  0: { companyName: "QuickClean Services", fullName: "Arjun Singh", contact: "9123456789", linkedin: "https://www.linkedin.com/in/arjunsingh", companyEmail: "arjun@quickclean.com", ideaYears: "2025", website: "", teamSize: "1" },
  1: { sector: "Others", incubationFocus: "!No", ideaTitle: "Home Cleaning Services Booking App", ai: "@No", applyIncubation: "Grant" },
  2: { problem: "People need someone to clean their homes.", ideaDescription: "An app where people can book home cleaning services in their city.", necessity: "Demand Validation", offeringType: "Service", painSegment: "Metro", businessModel: "B2C" },
  3: { problemKind: "Every Problem in oriented areas", productMaturity: "Idea Stage" },
  4: { unfairAdvantage: "Network", competition: "#Yes", competitorStage: "Scaling", coverageArea: "Same City / District", segmentation: "$No" },
  5: { cost: "%No", profit: "^No", financial: "&No", price: "*No", financingOptions: "Cash" },
  6: { bestFitChannel: "Community/Referrals", pricingCurrency: "Local currency", economic: "(No", ecommerce: ")No" },
  7: { revenueStreams: "Fees", costStructure: "Team", northStarMetric: "GMV" },
  8: { team: "-No", culture: "_No", genderService: "Male", deliveryMethod: "In person", complaintsPercent: "More than 50%", available: "+No" },
  9: { adopt20: "|No", legal: "}Yes", marketing: ":Yes", investorFit: "impact", idea: "{No" },
  10: { city: "Delhi", stateName: "Delhi", area: "<No", coe: ">No" },
};

const IDEA_FORM_STORAGE_KEY = "idea-validation-draft";

export default function IdeaValidationForm({setToggle,onClose}) {
  const prefersReducedMotion = useReducedMotion();

  const [formData, setFormData] = useState(() => {
    try {
      const saved = sessionStorage.getItem(IDEA_FORM_STORAGE_KEY);
      return saved ? JSON.parse(saved).formData || {} : {};
    } catch { return {}; }
  });
  const [revealedFields, setRevealedFields] = useState({});
  const [errors, setErrors] = useState({});
  const [activeStep, setActiveStep] = useState(() => {
    try {
      const saved = sessionStorage.getItem(IDEA_FORM_STORAGE_KEY);
      return saved ? JSON.parse(saved).activeStep || 0 : 0;
    } catch { return 0; }
  });
  const [maxReachedStep, setMaxReachedStep] = useState(() => {
    try {
      const saved = sessionStorage.getItem(IDEA_FORM_STORAGE_KEY);
      return saved ? JSON.parse(saved).maxReachedStep || 0 : 0;
    } catch { return 0; }
  });
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [score, setScore] = useState(0);
  const [submitError, setSubmitError] = useState("");
  const navigate = useNavigate();

  // Keep progressive revealed fields visible once they are unlocked
  useEffect(() => {
    setRevealedFields((prev) => {
      let changed = false;
      const nextRevealed = { ...prev };

      for (let s = 0; s <= 10; s++) {
        const stepData = formData[s] || {};
        if (!nextRevealed[s]) {
          nextRevealed[s] = {};
        }
        const prevStepRevealed = prev[s] || {};
        const nextStepRevealed = { ...prevStepRevealed };

        const reveal = (field) => {
          if (!nextStepRevealed[field]) {
            nextStepRevealed[field] = true;
            changed = true;
          }
        };

        // Step 0: Basic Info
        if (s === 0) {
          if (!!stepData.companyName?.trim()) reveal("fullName");
          if (!!stepData.fullName?.trim()) reveal("contact");
          if (stepData.contact?.trim().length === 10) reveal("linkedin");
          if (!!stepData.linkedin?.trim()) reveal("companyEmail");
          if (!!stepData.companyEmail?.trim()) reveal("ideaYears");
          if (!!stepData.ideaYears) reveal("website");
          if (!!stepData.ideaYears) reveal("teamSize");
        }
        // Step 1: Idea Intake
        else if (s === 1) {
          if (!!stepData.sector) reveal("incubationFocus");
          if (!!stepData.incubationFocus) reveal("ideaTitle");
          if (!!stepData.ideaTitle?.trim()) reveal("ai");
          if (!!stepData.ai) reveal("applyIncubation");
        }
        // Step 2: Problem & Customer Discovery
        else if (s === 2) {
          if (!!stepData.problem?.trim()) reveal("ideaDescription");
          if (!!stepData.ideaDescription?.trim()) reveal("necessity");
          if (!!stepData.necessity) reveal("offeringType");
          if (!!stepData.offeringType) reveal("painSegment");
          if (!!stepData.painSegment) reveal("businessModel");
        }
        // Step 3: Value Prop
        else if (s === 3) {
          if (!!stepData.problemKind) reveal("productMaturity");
        }
        // Step 4: Competitive Edge
        else if (s === 4) {
          if (!!stepData.unfairAdvantage) reveal("competition");
          if (!!stepData.competition) reveal("competitorStage");
          if (!!stepData.competitorStage) reveal("coverageArea");
          if (!!stepData.coverageArea) reveal("segmentation");
        }
        // Step 5: Affordability
        else if (s === 5) {
          if (!!stepData.cost) reveal("profit");
          if (!!stepData.profit) reveal("financial");
          if (!!stepData.financial) reveal("price");
          if (!!stepData.price) reveal("financingOptions");
        }
        // Step 6: Go-to-Market
        else if (s === 6) {
          if (!!stepData.bestFitChannel) reveal("pricingCurrency");
          if (!!stepData.pricingCurrency) reveal("economic");
          if (!!stepData.economic) reveal("ecommerce");
        }
        // Step 7: Revenue & Cost
        else if (s === 7) {
          if (!!stepData.revenueStreams) reveal("costStructure");
          if (!!stepData.costStructure) reveal("northStarMetric");
        }
        // Step 8: Accessibility
        else if (s === 8) {
          if (!!stepData.team) reveal("culture");
          if (!!stepData.culture) reveal("genderService");
          if (!!stepData.genderService) reveal("deliveryMethod");
          if (!!stepData.deliveryMethod) reveal("complaintsPercent");
          if (!!stepData.complaintsPercent) reveal("available");
        }
        // Step 9: Acceptability
        else if (s === 9) {
          if (!!stepData.adopt20) reveal("legal");
          if (!!stepData.legal) reveal("marketing");
          if (!!stepData.marketing) reveal("investorFit");
          if (!!stepData.investorFit) reveal("idea");
        }
        // Step 10: Area
        else if (s === 10) {
          if (!!stepData.city?.trim() && !!stepData.stateName?.trim()) reveal("area");
          if (stepData.area === "<Yes") reveal("collaborationOrg");
          if (stepData.area === "<No" || (stepData.area === "<Yes" && !!stepData.collaborationOrg)) {
            reveal("coe");
          }
        }

        if (changed) {
          nextRevealed[s] = nextStepRevealed;
        }
      }
      return changed ? nextRevealed : prev;
    });
  }, [formData]);
  
  // Persist draft to sessionStorage so state survives login redirects
  useEffect(() => {
    try {
      sessionStorage.setItem(IDEA_FORM_STORAGE_KEY, JSON.stringify({ formData, activeStep, maxReachedStep }));
    } catch {}
  }, [formData, activeStep, maxReachedStep]);

  // Track the furthest step the user has ever progressed past
  useEffect(() => {
    setMaxReachedStep((prev) => Math.max(prev, activeStep));
  }, [activeStep]);

  // Auto-advance on chip-only steps (3-9) only on first visit
  useEffect(() => {
    const CHIP_STEPS = [3, 4, 5, 6, 7, 8, 9];
    if (!CHIP_STEPS.includes(activeStep)) return;
    if (activeStep < maxReachedStep) return;
    const stepData = formData[activeStep] || {};
    const required = getRequiredFieldsForStep(activeStep, stepData);
    const allFilled = required.every((f) => !!stepData[f]);
    if (!allFilled) return;
    const timer = setTimeout(() => {
      setActiveStep((prev) => Math.min(prev + 1, 10));
    }, 700);
    return () => clearTimeout(timer);
  }, [formData, activeStep, maxReachedStep]);

  const [showMissingFieldsPopup, setShowMissingFieldsPopup] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [missingStepIndex, setMissingStepIndex] = useState(null);
  const { activeTheme } = useContext(ThemeContext);
  const [reportData, setReportData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSampleIdea, setIsSampleIdea] = useState(false);
  const { user } = useAuth();
  const { requireAuth } = useRequireAuth();
  const isBypassUser = user?.email?.trim().toLowerCase() === "marsmatedemo@gmail.com" || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

  
 

  // ✅ Redirect to Scorecard on Submit
  useEffect(() => {
    if (submitted && reportData) {
      sessionStorage.removeItem(IDEA_FORM_STORAGE_KEY);
      const isLocked = reportData?.requiresPayment === true && !isBypassUser;
      if (!isLocked) {
        localStorage.setItem("scorecardAccess", "true");
        localStorage.setItem("scorecardtoken", "true");
      }

      const partA = crypto.randomUUID() + crypto.randomUUID();
      const partB = crypto.randomUUID() + crypto.randomUUID();
      localStorage.setItem("reportPartA", partA);
      localStorage.setItem("reportPartB", partB);

      setToggle(false);
      onClose();
      navigate(`/scorecard`, { replace: true });
    }
  }, [submitted,reportData,navigate,isBypassUser,setToggle,onClose]);

  const prefillForm = (type) => {
    const data = type === "strong" ? STRONG_IDEA_DATA : WEAK_IDEA_DATA;
    setIsSampleIdea(true);
    setFormData(data);
    const s1 = data[1]; const s5 = data[5]; const s6 = data[6];
    const s8 = data[8]; const s9 = data[9]; const s10 = data[10]; const s4 = data[4];
    setIncubationFocus(s1.incubationFocus);
    setAi(s1.ai);
    setCost(s5.cost); setProfit(s5.profit); setFinancial(s5.financial); setPrice(s5.price);
    setEconomic(s6.economic); setEcommerce(s6.ecommerce);
    setTeam(s8.team); setCulture(s8.culture); setAvailable(s8.available);
    setAdopt20(s9.adopt20); setLegal(s9.legal); setMarket(s9.marketing); setIdea(s9.idea);
    setArea(s10.area); setCoe(s10.coe); setCity(s10.city); setStateName(s10.stateName);
    setCompitition(s4.competition); setSegmentation(s4.segmentation);
    // ✅ Auto-verify all links for Strong Idea prefill (real verified data)
    if (type === "strong") {
      setLinkStatus({ linkedin: true, website: true, companyEmail: true });
    }
    setActiveStep(0);
  };

  const clearForm = () => {
    setFormData({});
    setActiveStep(0);
    setMaxReachedStep(0);
    setRevealedFields({});
    setErrors({});
    setIsSampleIdea(false);
    setTeam(""); setCulture(""); setEconomic(""); setEcommerce(""); setSegmentation("");
    setCost(""); setProfit(""); setFinancial(""); setPrice("");
    setIncubationFocus(""); setAi("");
    setAvailable(""); setIdea(""); setLegal(""); setMarket(""); setAdopt20("");
    setArea(""); setCoe(""); setCity(""); setStateName(""); setCompitition("");
    setLinkStatus({ website: null, linkedin: null, companyEmail: null });
    sessionStorage.removeItem(IDEA_FORM_STORAGE_KEY);
  };

  // ✅ Same reliable pattern as MindMappingForm handleBackStep
  const handleBackStep = () => {
    setActiveStep((prev) => {
      const target = prev - 1;
      return target < 0 ? 0 : target;
    });
  };

  const [sectorSearch, setSectorSearch] = useState("");
  const [showSectorDropdown, setShowSectorDropdown] = useState(false);

  // Link/Email availability status per field
  // null = unchecked, true = verified reachable, false = invalid/unreachable
  const [linkStatus, setLinkStatus] = useState({ website: null, linkedin: null, companyEmail: null });
  const [linkChecking, setLinkChecking] = useState({ website: false, linkedin: false, companyEmail: false });
  const linkDebounceRef = useRef({});

  const isValidEmail = (val) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((val || "").trim());

  const checkLinkStatus = async (fieldName, type, value) => {
    if (!value || !value.trim()) {
      setLinkStatus(prev => ({ ...prev, [fieldName]: null }));
      return;
    }
    setLinkChecking(prev => ({ ...prev, [fieldName]: true }));
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
      const response = await fetch(`${backendUrl}/idea-validation/check-link`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type, value: value.trim() }),
        credentials: "include",
      });
      const data = await response.json();
      setLinkStatus(prev => ({ ...prev, [fieldName]: data.available }));
    } catch {
      setLinkStatus(prev => ({ ...prev, [fieldName]: false }));
    } finally {
      setLinkChecking(prev => ({ ...prev, [fieldName]: false }));
    }
  };

  // Debounced live check — fires 800ms after the user stops typing
  const scheduleLinkCheck = (fieldName, type, value) => {
    clearTimeout(linkDebounceRef.current[fieldName]);
    if (!value || !value.trim()) {
      setLinkStatus(prev => ({ ...prev, [fieldName]: null }));
      setLinkChecking(prev => ({ ...prev, [fieldName]: false }));
      return;
    }
    // Show spinner immediately so the user knows a check is pending
    setLinkChecking(prev => ({ ...prev, [fieldName]: true }));
    linkDebounceRef.current[fieldName] = setTimeout(() => {
      checkLinkStatus(fieldName, type, value);
    }, 800);
  };

  // Re-run link checks whenever step-0 values change (covers sample button, paste, autofill)
  const s0linkedin     = formData[0]?.linkedin;
  const s0website      = formData[0]?.website;
  const s0companyEmail = formData[0]?.companyEmail;

  useEffect(() => {
    if (s0linkedin) {
      // Skip debounced check if already verified by prefill
      setLinkStatus(prev => {
        if (prev.linkedin === true) return prev;
        scheduleLinkCheck("linkedin", "linkedin", s0linkedin);
        return prev;
      });
    } else {
      setLinkStatus(prev => ({ ...prev, linkedin: null }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [s0linkedin]);

  useEffect(() => {
    if (s0website) {
      // Skip debounced check if already verified by prefill
      setLinkStatus(prev => {
        if (prev.website === true) return prev;
        scheduleLinkCheck("website", "url", s0website);
        return prev;
      });
    } else {
      setLinkStatus(prev => ({ ...prev, website: null }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [s0website]);

  useEffect(() => {
    if (s0companyEmail) {
      setLinkStatus(prev => {
        // If already verified by prefill, keep it
        if (prev.companyEmail === true) return prev;
        return { ...prev, companyEmail: isValidEmail(s0companyEmail) };
      });
    } else {
      setLinkStatus(prev => ({ ...prev, companyEmail: null }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [s0companyEmail]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest('.searchable-select-container')) {
        setShowSectorDropdown(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, []);

  // YES/NO and other stateful fields
  const [team, setTeam] = useState("");
  const [culture, setCulture] = useState("");
  const [economic, setEconomic] = useState("");
  const [ecommerce, setEcommerce] = useState("");
  const [segmentation, setSegmentation] = useState("");
  const [cost, setCost] = useState("");
  const [profit, setProfit] = useState("");
  const [financial, setFinancial] = useState("");
  const [price, setPrice] = useState("");
  const [incubationFocus, setIncubationFocus] = useState("");
  const [ai, setAi] = useState("");
  const [available, setAvailable] = useState("");
  const [idea, setIdea] = useState("");
  const [legal, setLegal] = useState("");
  const [market, setMarket] = useState("");
  const [adopt20, setAdopt20] = useState("");
  const [area, setArea] = useState("");
  const [coe, setCoe] = useState("");
  const [city, setCity] = useState("");
  const [stateName, setStateName] = useState("");
  const [compitition, setCompitition] = useState("");

  const steps = [
    "Basic Info",
    "Idea Intake",
    "Problem & Discovery",
    "Value Proposition",
    "Competitive Edge",
    "Affordability",
    "Go-to-Market",
    "Revenue & Cost",
    "Accessibility",
    "Acceptability",
    "Area",
  ];

  const stepIcons = ["👤","💡","🔍","💎","⚡","💰","🚀","📊","♿","✅","📍"];

  const updateStepData = (index, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [key]: value,
      },
    }));

    setErrors((prev) => ({
      ...prev,
      [key]: "",
    }));
  };

  // Prevent UI flash until tokens are generated
  

  const renderStepForm = (index) => {
    const stepData = formData[index] || {};

    switch (index) {
      case 0: {
        const showFullName = !!stepData.companyName?.trim() || !!revealedFields[0]?.fullName;
        const showContact = (showFullName && !!stepData.fullName?.trim()) || !!revealedFields[0]?.contact;
        const showLinkedin = (showContact && stepData.contact?.trim().length === 10) || !!revealedFields[0]?.linkedin;
        const showCompanyEmail = (showLinkedin && !!stepData.linkedin?.trim()) || !!revealedFields[0]?.companyEmail;
        const showIdeaYears = (showCompanyEmail && !!stepData.companyEmail?.trim()) || !!revealedFields[0]?.ideaYears;
        const showWebsite = (showIdeaYears && !!stepData.ideaYears) || !!revealedFields[0]?.website;
        const showTeamSize = (showIdeaYears && !!stepData.ideaYears) || !!revealedFields[0]?.teamSize;

        return (
          <div className="form two-column">
            <div className="query-fade-in">
              <label>Company Name</label>
              <input
                type="text"
                name="companyName"
                placeholder="Company Name"
                value={stepData.companyName || ""}
                onChange={(e) => updateStepData(index, "companyName", e.target.value)}
                required
              />
            </div>
            {showFullName && (
              <div className="query-fade-in">
                <label>Name (First/Last)</label>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Name (First/Last)"
                  value={stepData.fullName || ""}
                  onChange={(e) => updateStepData(index, "fullName", e.target.value)}
                  required
                />
              </div>
            )}
            {showContact && (
              <div className="query-fade-in">
                <label>Contact</label>
                <div className="link-check-wrapper">
                  <input
                    type="tel"
                    name="contact"
                    placeholder="Contact number"
                    value={stepData.contact || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        updateStepData(index, "contact", value);
                      }
                    }}
                    maxLength={10}
                    required
                  />
                  {stepData.contact?.length === 10 && /^[6-9]\d{9}$/.test(stepData.contact) ? (
                    <span className="link-status-badge available" title="Valid contact number">✅</span>
                  ) : (
                    stepData.contact && stepData.contact.length > 0 && (
                      <span className="link-status-badge unavailable" title="Invalid contact number (must be 10 digits starting with 6-9)">✕</span>
                    )
                  )}
                </div>
                {errors.contact && <div className="error">{errors.contact}</div>}
              </div>
            )}
            {showLinkedin && (
              <div className="query-fade-in">
                <label>LinkedIn</label>
                <div className="link-check-wrapper">
                  <input
                    type="text"
                    name="linkedin"
                    placeholder="LinkedIn profile URL"
                    value={stepData.linkedin || ""}
                    required
                    onChange={(e) => {
                      const val = e.target.value;
                      updateStepData(index, "linkedin", val);
                      scheduleLinkCheck("linkedin", "linkedin", val);
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      if (!val.trim()) return;
                      // Cancel debounce and fire immediately on blur
                      clearTimeout(linkDebounceRef.current.linkedin);
                      checkLinkStatus("linkedin", "linkedin", val);
                    }}
                  />
                  {linkChecking.linkedin && <span className="link-status-badge checking">⏳</span>}
                  {!linkChecking.linkedin && linkStatus.linkedin === true && <span className="link-status-badge available" title="LinkedIn profile verified ✓">✅</span>}
                  {!linkChecking.linkedin && linkStatus.linkedin === false && <span className="link-status-badge unavailable" title="Profile not reachable. Use: https://linkedin.com/in/yourname">!</span>}
                </div>
              </div>
            )}
            {showCompanyEmail && (
              <div className="query-fade-in">
                <label>Company Email</label>
                <div className="link-check-wrapper">
                  <input
                    type="text"
                    name="companyEmail"
                    placeholder="company@example.com"
                    value={stepData.companyEmail || ""}
                    required
                    onChange={(e) => {
                      const val = e.target.value;
                      updateStepData(index, "companyEmail", val);
                      if (!val.trim()) {
                        setLinkStatus(prev => ({ ...prev, companyEmail: null }));
                      } else {
                        setLinkStatus(prev => ({ ...prev, companyEmail: isValidEmail(val) }));
                      }
                    }}
                  />
                  {!linkChecking.companyEmail && linkStatus.companyEmail === true && <span className="link-status-badge available" title="Valid email format ✓">✅</span>}
                  {!linkChecking.companyEmail && linkStatus.companyEmail === false && <span className="link-status-badge unavailable" title="Invalid email format">!</span>}
                </div>
              </div>
            )}
            {showIdeaYears && (
              <div className="query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Working on Idea Since (2020–{new Date().getFullYear().toString().slice(-2)})
                </label>
                <div className="options-btn-row">
                  {["2020", "2021", "2022", "2023", "2024", "2025", "2026"].map((year) => (
                    <button
                      key={year}
                      type="button"
                      className={`option-btn ${stepData.ideaYears === year ? "selected" : ""}`}
                      onClick={() => updateStepData(index, "ideaYears", year)}
                    >
                      {year}
                    </button>
                  ))}
                </div>
                <input 
                  type="text" 
                  name="ideaYears" 
                  value={stepData.ideaYears || ""} 
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }} 
                  required 
                  readOnly
                />
              </div>
            )}
            {showWebsite && (
              <div className="query-fade-in">
                <label>Website</label>
                <div className="link-check-wrapper">
                  <input
                    type="text"
                    name="website"
                    placeholder="https://yourwebsite.com (optional)"
                    value={stepData.website || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      updateStepData(index, "website", val);
                      scheduleLinkCheck("website", "url", val);
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      if (!val.trim()) return;
                      clearTimeout(linkDebounceRef.current.website);
                      checkLinkStatus("website", "url", val);
                    }}
                  />
                  {linkChecking.website && <span className="link-status-badge checking">⏳</span>}
                  {!linkChecking.website && linkStatus.website === true && <span className="link-status-badge available" title="Website is live ✓">✅</span>}
                  {!linkChecking.website && linkStatus.website === false && <span className="link-status-badge unavailable" title="Website not reachable">!</span>}
                </div>
              </div>
            )}
            {showTeamSize && (
              <div className="query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Team Members (1–10+)</label>
                <div className="options-btn-row">
                  {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"].map((size) => (
                    <button
                      key={size}
                      type="button"
                      className={`option-btn ${stepData.teamSize === size ? "selected" : ""}`}
                      onClick={() => updateStepData(index, "teamSize", size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
                <input 
                  type="text" 
                  name="teamSize" 
                  value={stepData.teamSize || ""} 
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }} 
                  required 
                  readOnly
                />
              </div>
            )}
          </div>
        );
      }

      case 1: {
        const showIncubationFocus = !!stepData.sector || !!revealedFields[1]?.incubationFocus;
        const showIdeaTitle = (showIncubationFocus && !!stepData.incubationFocus) || !!revealedFields[1]?.ideaTitle;
        const showAi = (showIdeaTitle && !!stepData.ideaTitle?.trim()) || !!revealedFields[1]?.ai;
        const showApplyIncubation = (showAi && !!stepData.ai) || !!revealedFields[1]?.applyIncubation;

        return (
          <div className="form">
            <div className="input-group searchable-select-container query-fade-in">
              <label>DPIIT/NIC Sector-Wise Classification (Select Your Sector)</label>
              
              <div className="searchable-select-wrapper">
                <div 
                  className={`searchable-select-trigger ${showSectorDropdown ? "open" : ""}`}
                  onClick={() => setShowSectorDropdown(!showSectorDropdown)}
                >
                  <span>{stepData.sector || "Select sector"}</span>
                  <span className="arrow-icon">▼</span>
                </div>
                
                {showSectorDropdown && (
                  <div className="searchable-select-dropdown">
                    <div className="searchable-select-search-box" onClick={(e) => e.stopPropagation()}>
                      <input
                        type="text"
                        placeholder="Search sector..."
                        value={sectorSearch}
                        onChange={(e) => setSectorSearch(e.target.value)}
                        autoFocus
                      />
                      {sectorSearch && (
                        <button 
                          type="button" 
                          className="clear-search-btn"
                          onClick={() => setSectorSearch("")}
                        >
                          ✕
                        </button>
                      )}
                    </div>
                    
                    <div className="searchable-select-options-list">
                      {(SECTOR_OPTIONS.filter((option) =>
                        option.label.toLowerCase().includes(sectorSearch.toLowerCase())
                      )).length > 0 ? (
                        (SECTOR_OPTIONS.filter((option) =>
                          option.label.toLowerCase().includes(sectorSearch.toLowerCase())
                        )).map((option, idx) => (
                          <div
                            key={`${option.value}-${idx}`}
                            className={`searchable-select-option ${stepData.sector === option.value ? "selected" : ""}`}
                            onClick={() => {
                              updateStepData(index, "sector", option.value);
                              setShowSectorDropdown(false);
                              setSectorSearch("");
                            }}
                          >
                            {option.label}
                          </div>
                        ))
                      ) : (
                        <div className="searchable-select-no-results">No sectors found</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              
              <input
                type="text"
                name="sector"
                value={stepData.sector || ""}
                style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                required
                readOnly
              />
            </div>

            {showIncubationFocus && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Is it belongs to the Incubation / Investor focus sector?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.incubationFocus === "!Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setIncubationFocus("!Yes");
                      updateStepData(index, "incubationFocus", "!Yes");
                      localStorage.setItem("incubationFocus", "yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.incubationFocus === "!No" ? "selected" : ""}`}
                    onClick={() => {
                      setIncubationFocus("!No");
                      updateStepData(index, "incubationFocus", "!No");
                      localStorage.setItem("incubationFocus", "no");
                    }}
                  >
                    No
                  </button>
                </div>
                <input 
                  type="text" 
                  name="incubationFocus" 
                  value={stepData.incubationFocus || ""} 
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }} 
                  required 
                  readOnly
                />
              </div>
            )}

            {showIdeaTitle && (
              <div className="input-group query-fade-in">
                <label>Founder submits an Idea / Title</label>
                <input
                  type="text"
                  name="ideaTitle"
                  placeholder="Enter your idea title"
                  value={stepData.ideaTitle || ""}
                  onChange={(e) => updateStepData(index, "ideaTitle", e.target.value)}
                  required
                />
              </div>
            )}

            {showAi && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Very forward-thinking question — are you adding AI feature?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.ai === "@Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setAi("@Yes");
                      updateStepData(index, "ai", "@Yes");
                      localStorage.setItem("ai", "yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.ai === "@No" ? "selected" : ""}`}
                    onClick={() => {
                      setAi("@No");
                      updateStepData(index, "ai", "@No");
                      localStorage.setItem("ai", "no");
                    }}
                  >
                    No
                  </button>
                </div>
                <input 
                  type="text" 
                  name="ai" 
                  value={stepData.ai || ""} 
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }} 
                  required 
                  readOnly
                />
              </div>
            )}

            {showApplyIncubation && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Would you like to apply for incubation?</label>
                <div className="options-btn-row">
                  {["Grant", "Investments", "Space", "Mentorship"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.applyIncubation === opt ? "selected" : ""}`}
                      onClick={() => updateStepData(index, "applyIncubation", opt)}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input 
                  type="text" 
                  name="applyIncubation" 
                  value={stepData.applyIncubation || ""} 
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }} 
                  required 
                  readOnly
                />
              </div>
            )}
          </div>
        );
      }

      case 2: {
        const showIdeaDescription = !!stepData.problem?.trim() || !!revealedFields[2]?.ideaDescription;
        const showNecessity = (showIdeaDescription && !!stepData.ideaDescription?.trim()) || !!revealedFields[2]?.necessity;
        const showOfferingType = (showNecessity && !!stepData.necessity) || !!revealedFields[2]?.offeringType;
        const showPainSegment = (showOfferingType && !!stepData.offeringType) || !!revealedFields[2]?.painSegment;
        const showBusinessModel = (showPainSegment && !!stepData.painSegment) || !!revealedFields[2]?.businessModel;

        return (
          <>
            <div className="input-group query-fade-in">
              <label>What exact problem do you solve?</label>
              <textarea
                name="problem"
                placeholder="Describe the problem"
                rows="3"
                value={stepData.problem || ""}
                onChange={(e) => updateStepData(index, "problem", e.target.value)}
                required
              ></textarea>
            </div>

            {showIdeaDescription && (
              <div className="input-group query-fade-in">
                <label>Describe the idea/solution to the problem?</label>
                <textarea
                  name="ideaDescription"
                  placeholder="Describe the idea"
                  rows="3"
                  value={stepData.ideaDescription || ""}
                  onChange={(e) => updateStepData(index, "ideaDescription", e.target.value)}
                  required
                ></textarea>
              </div>
            )}

            {showNecessity && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Is there any necessity to your product?</label>
                <div className="options-btn-row">
                  {["Demand Validation", "Market Need"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.necessity === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "necessity", opt);
                        localStorage.setItem("necessity", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="necessity"
                  value={stepData.necessity || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showOfferingType && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Startup focus on service or product-based offerings?</label>
                <div className="options-btn-row">
                  {["Service", "Product"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.offeringType === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "offeringType", opt);
                        localStorage.setItem("offeringType", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="offeringType"
                  value={stepData.offeringType || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showPainSegment && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Who (people/organizations) feel this pain most?</label>
                <div className="options-btn-row">
                  {["Metro", "Town", "Block", "Rurals", "Companies", "Govt"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.painSegment === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "painSegment", opt);
                        localStorage.setItem("painSegment", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="painSegment"
                  value={stepData.painSegment || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showBusinessModel && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Describe different business models based on the customer type:</label>
                <div className="options-btn-row">
                  {["B2B", "B2C", "B2B2C", "C2C", "SME"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.businessModel === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "businessModel", opt);
                        localStorage.setItem("businessModel", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="businessModel"
                  value={stepData.businessModel || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      case 3: {
        const showProductMaturity = !!stepData.problemKind || !!revealedFields[3]?.productMaturity;

        return (
          <>
            <div className="input-group query-fade-in">
              <label style={{ display: 'block', marginBottom: '8px' }}>Are you solving which kind of problem?</label>
              <div className="options-btn-row">
                {["Every Problem in oriented areas", "Unique Problem in oriented areas"].map((opt) => (
                  <button
                    key={opt}
                    type="button"
                    className={`option-btn ${stepData.problemKind === opt ? "selected" : ""}`}
                    onClick={() => {
                      updateStepData(activeStep, "problemKind", opt);
                      localStorage.setItem("problemKind", opt);
                    }}
                  >
                    {opt}
                  </button>
                ))}
              </div>
              <input
                type="text"
                name="problemKind"
                value={stepData.problemKind || ""}
                style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                required
                readOnly
              />
            </div>

            {showProductMaturity && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>What's your product maturity?</label>
                <div className="options-btn-row">
                  {[
                    { value: "Idea Stage", label: "Idea stage" },
                    { value: "POC - MVP", label: "POC-MVP" },
                    { value: "PMF", label: "PMF" },
                    { value: "Scaling Stage", label: "Scaling Stage" }
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      className={`option-btn ${stepData.productMaturity === opt.value ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "productMaturity", opt.value);
                        localStorage.setItem("productMaturity", opt.value);
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="productMaturity"
                  value={stepData.productMaturity || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      case 4: {
        const showCompetition = !!stepData.unfairAdvantage || !!revealedFields[4]?.competition;
        const showCompetitorStage = (showCompetition && !!stepData.competition) || !!revealedFields[4]?.competitorStage;
        const showCoverageArea = (showCompetitorStage && !!stepData.competitorStage) || !!revealedFields[4]?.coverageArea;
        const showSegmentation = (showCoverageArea && !!stepData.coverageArea) || !!revealedFields[4]?.segmentation;

        return (
          <>
            <div className="input-group query-fade-in">
              <label style={{ display: 'block', marginBottom: '8px' }}>
                When investors evaluate unfair advantage, they're looking for
                defensible strengths that make your startup hard to copy. Do you
                have any?
              </label>
              <div className="options-btn-row">
                {[
                  "IP",
                  "Network",
                  "Partnerships",
                  "Capital Access",
                  "Brand / Trust / Data Asset",
                  "Regulatory License / Compliance Edge"
                ].map((opt) => (
                  <button
                    key={opt}
                    type="button"
                    className={`option-btn ${stepData.unfairAdvantage === opt ? "selected" : ""}`}
                    onClick={() => {
                      updateStepData(activeStep, "unfairAdvantage", opt);
                      localStorage.setItem("unfairAdvantage", opt);
                    }}
                  >
                    {opt}
                  </button>
                ))}
              </div>
              <input
                type="text"
                name="unfairAdvantage"
                value={stepData.unfairAdvantage || ""}
                style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                required
                readOnly
              />
            </div>

            {showCompetition && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Competition Analysis: Do you have another competitor in your location..?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.competition === "#Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setCompitition("#Yes");
                      updateStepData(activeStep, "competition", "#Yes");
                      localStorage.setItem("competition", "#yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.competition === "#No" ? "selected" : ""}`}
                    onClick={() => {
                      setCompitition("#No");
                      updateStepData(activeStep, "competition", "#No");
                      localStorage.setItem("competition", "#No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="competition"
                  value={stepData.competition || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showCompetitorStage && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Competitor Stage?</label>
                <div className="options-btn-row">
                  {["Early Traction", "Prototype", "Scaling", "Validation"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.competitorStage === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "competitorStage", opt);
                        localStorage.setItem("competitorStage", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="competitorStage"
                  value={stepData.competitorStage || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showCoverageArea && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Strategic and analytical: competitor coverage area, why competitors
                  choose certain markets, and what you should do if they're not present.
                </label>
                <div className="options-btn-row">
                  {["Same City / District", "State", "Country", "Foreign"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.coverageArea === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "coverageArea", opt);
                        localStorage.setItem("coverageArea", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="coverageArea"
                  value={stepData.coverageArea || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showSegmentation && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Competitor target segmentation. You're analyzing whether your
                  competitors serve the same type of clients as you, or a
                  different segment—and how to act in (Ex: Vehicle &amp; person
                  insurance)
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.segmentation === "$Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setSegmentation("$Yes");
                      updateStepData(activeStep, "segmentation", "$Yes");
                      localStorage.setItem("segmentation", "$yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.segmentation === "$No" ? "selected" : ""}`}
                    onClick={() => {
                      setSegmentation("$No");
                      updateStepData(activeStep, "segmentation", "$No");
                      localStorage.setItem("segmentation", "$No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="segmentation"
                  value={stepData.segmentation || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      case 5: {
        const showProfit = !!stepData.cost || !!revealedFields[5]?.profit;
        const showFinancial = (showProfit && !!stepData.profit) || !!revealedFields[5]?.financial;
        const showPrice = (showFinancial && !!stepData.financial) || !!revealedFields[5]?.price;
        const showFinancingOptions = (showPrice && !!stepData.price) || !!revealedFields[5]?.financingOptions;

        return (
          <>
            <div className="input-group query-fade-in">
              <label style={{ display: 'block', marginBottom: '8px' }}>
                Do you / your team ready to bear the prototype cost (Approx:
                5–20L)?
              </label>
              <div className="options-btn-row">
                <button
                  type="button"
                  className={`option-btn ${stepData.cost === "%Yes" ? "selected" : ""}`}
                  onClick={() => {
                    setCost("%Yes");
                    updateStepData(activeStep, "cost", "%Yes");
                    localStorage.setItem("cost", "%Yes");
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className={`option-btn ${stepData.cost === "%No" ? "selected" : ""}`}
                  onClick={() => {
                    setCost("%No");
                    updateStepData(activeStep, "cost", "%No");
                    localStorage.setItem("cost", "%No");
                  }}
                >
                  No
                </button>
              </div>
              <input
                type="text"
                name="cost"
                value={stepData.cost || ""}
                style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                required
                readOnly
              />
            </div>

            {showProfit && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  When you believe in your idea, you can survive up to 3 years
                  (1000 days) even when the company is not getting profits. Do you
                  agree?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.profit === "^Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setProfit("^Yes");
                      updateStepData(activeStep, "profit", "^Yes");
                      localStorage.setItem("profit", "^Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.profit === "^no" ? "selected" : ""}`}
                    onClick={() => {
                      setProfit("^no");
                      updateStepData(activeStep, "profit", "^no");
                      localStorage.setItem("profit", "^no");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="profit"
                  value={stepData.profit || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showFinancial && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Focuses on financial stability and backup planning, which is
                  critical for founders — especially in the early stage when the
                  startup isn't profitable yet.
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.financial === "&Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setFinancial("&Yes");
                      updateStepData(activeStep, "financial", "&Yes");
                      localStorage.setItem("financial", "&Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.financial === "&No" ? "selected" : ""}`}
                    onClick={() => {
                      setFinancial("&No");
                      updateStepData(activeStep, "financial", "&No");
                      localStorage.setItem("financial", "&No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="financial"
                  value={stepData.financial || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showPrice && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  You're touching on pricing–market fit, which determines how well
                  your product's price matches what your target customers can
                  afford. Do you have clarity on that?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.price === "*Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setPrice("*Yes");
                      updateStepData(activeStep, "price", "*Yes");
                      localStorage.setItem("price", "*Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.price === "*No" ? "selected" : ""}`}
                    onClick={() => {
                      setPrice("*No");
                      updateStepData(activeStep, "price", "*No");
                      localStorage.setItem("price", "*No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="price"
                  value={stepData.price || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showFinancingOptions && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Are there financing options?</label>
                <div className="options-btn-row">
                  {["Installment Plans", "Subsidies", "Cash"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.financingOptions === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "financingOptions", opt);
                        localStorage.setItem("financingOptions", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="financingOptions"
                  value={stepData.financingOptions || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      case 6: {
        const showPricingCurrency = !!stepData.bestFitChannel || !!revealedFields[6]?.pricingCurrency;
        const showEconomic = (showPricingCurrency && !!stepData.pricingCurrency) || !!revealedFields[6]?.economic;
        const showEcommerce = (showEconomic && !!stepData.economic) || !!revealedFields[6]?.ecommerce;

        return (
          <>
            <div className="input-group query-fade-in">
              <label style={{ display: 'block', marginBottom: '8px' }}>It recommends best-fit channels</label>
              <div className="options-btn-row">
                {["Offline/Retail", "Community/Referrals", "social media", "B2B Partnerships", "App Stores", "Govt/Institutional"].map((opt) => (
                  <button
                    key={opt}
                    type="button"
                    className={`option-btn ${stepData.bestFitChannel === opt ? "selected" : ""}`}
                    onClick={() => {
                      updateStepData(activeStep, "bestFitChannel", opt);
                      localStorage.setItem("bestFitChannel", opt);
                    }}
                  >
                    {opt}
                  </button>
                ))}
              </div>
              <input
                type="text"
                name="bestFitChannel"
                value={stepData.bestFitChannel || ""}
                style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                required
                readOnly
              />
            </div>

            {showPricingCurrency && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Cost of service/product (can simulate CAC vs ROI)
                </label>
                <div className="options-btn-row">
                  {["In dollars", "Local currency"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.pricingCurrency === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "pricingCurrency", opt);
                        localStorage.setItem("pricingCurrency", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="pricingCurrency"
                  value={stepData.pricingCurrency || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showEconomic && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Price matching to the household income level / economic capacity
                  of individuals to pay per service or good?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.economic === "(Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setEconomic("(Yes");
                      updateStepData(activeStep, "economic", "(Yes");
                      localStorage.setItem("economic", "(Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.economic === "(No" ? "selected" : ""}`}
                    onClick={() => {
                      setEconomic("(No");
                      updateStepData(activeStep, "economic", "(No");
                      localStorage.setItem("economic", "(No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="economic"
                  value={stepData.economic || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showEcommerce && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  User accessibility &amp; ease of use of the product or service?
                  (Like e-commerce)
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.ecommerce === ")Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setEcommerce(")Yes");
                      updateStepData(activeStep, "ecommerce", ")Yes");
                      localStorage.setItem("ecommerce", ")Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.ecommerce === ")No" ? "selected" : ""}`}
                    onClick={() => {
                      setEcommerce(")No");
                      updateStepData(activeStep, "ecommerce", ")No");
                      localStorage.setItem("ecommerce", ")No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="ecommerce"
                  value={stepData.ecommerce || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      case 7: {
        const showCostStructure = !!stepData.revenueStreams || !!revealedFields[7]?.costStructure;
        const showNorthStarMetric = (showCostStructure && !!stepData.costStructure) || !!revealedFields[7]?.northStarMetric;

        return (
          <>
            <div className="input-group query-fade-in">
              <label style={{ display: 'block', marginBottom: '8px' }}>Revenue Streams</label>
              <div className="options-btn-row">
                {["Subscription", "Ads", "Fees"].map((opt) => (
                  <button
                    key={opt}
                    type="button"
                    className={`option-btn ${stepData.revenueStreams === opt ? "selected" : ""}`}
                    onClick={() => {
                      updateStepData(activeStep, "revenueStreams", opt);
                      localStorage.setItem("revenueStreams", opt);
                    }}
                  >
                    {opt}
                  </button>
                ))}
              </div>
              <input
                type="text"
                name="revenueStreams"
                value={stepData.revenueStreams || ""}
                style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                required
                readOnly
              />
            </div>

            {showCostStructure && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Cost Structure</label>
                <div className="options-btn-row">
                  {[
                    { value: "Team", label: "Team" },
                    { value: "Infra", label: "Infra" },
                    { value: "~Marketing", label: "Marketing" }
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      className={`option-btn ${stepData.costStructure === opt.value ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "costStructure", opt.value);
                        localStorage.setItem("costStructure", opt.value);
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="costStructure"
                  value={stepData.costStructure || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showNorthStarMetric && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Engine helps founders define North Star metric</label>
                <div className="options-btn-row">
                  {["Active Users", "GMV", "Retention"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.northStarMetric === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "northStarMetric", opt);
                        localStorage.setItem("northStarMetric", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="northStarMetric"
                  value={stepData.northStarMetric || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      case 8: {
        const showCulture = !!stepData.team || !!revealedFields[8]?.culture;
        const showGenderService = (showCulture && !!stepData.culture) || !!revealedFields[8]?.genderService;
        const showDeliveryMethod = (showGenderService && !!stepData.genderService) || !!revealedFields[8]?.deliveryMethod;
        const showComplaintsPercent = (showDeliveryMethod && !!stepData.deliveryMethod) || !!revealedFields[8]?.complaintsPercent;
        const showAvailable = (showComplaintsPercent && !!stepData.complaintsPercent) || !!revealedFields[8]?.available;

        return (
          <>
            <div className="input-group query-fade-in">
              <label style={{ display: 'block', marginBottom: '8px' }}>
                Do you/your team/mentor know the in-depth information related to
                the idea?
              </label>
              <div className="options-btn-row">
                <button
                  type="button"
                  className={`option-btn ${stepData.team === "-Yes" ? "selected" : ""}`}
                  onClick={() => {
                    setTeam("-Yes");
                    updateStepData(activeStep, "team", "-Yes");
                    localStorage.setItem("team", "-Yes");
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className={`option-btn ${stepData.team === "-No" ? "selected" : ""}`}
                  onClick={() => {
                    setTeam("-No");
                    updateStepData(activeStep, "team", "-No");
                    localStorage.setItem("team", "-No");
                  }}
                >
                  No
                </button>
              </div>
              <input
                type="text"
                name="team"
                value={stepData.team || ""}
                style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                required
                readOnly
              />
            </div>

            {showCulture && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Will you measure how well services align with cultural, social,
                  and personal expectations, including language support (culture
                  beats strategy)?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.culture === "_Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setCulture("_Yes");
                      updateStepData(activeStep, "culture", "_Yes");
                      localStorage.setItem("culture", "_Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.culture === "_No" ? "selected" : ""}`}
                    onClick={() => {
                      setCulture("_No");
                      updateStepData(activeStep, "culture", "_No");
                      localStorage.setItem("culture", "_No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="culture"
                  value={stepData.culture || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showGenderService && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Gender-sensitive services</label>
                <div className="options-btn-row">
                  {["Male", "Female", "Others"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.genderService === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "genderService", opt);
                        localStorage.setItem("genderService", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="genderService"
                  value={stepData.genderService || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showDeliveryMethod && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Service delivery method preference</label>
                <div className="options-btn-row">
                  {["Digital", "In person"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.deliveryMethod === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "deliveryMethod", opt);
                        localStorage.setItem("deliveryMethod", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="deliveryMethod"
                  value={stepData.deliveryMethod || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showComplaintsPercent && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Complaints from users</label>
                <div className="options-btn-row">
                  {["10%", "20%", "30%", "40%", "More than 50%"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.complaintsPercent === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "complaintsPercent", opt);
                        localStorage.setItem("complaintsPercent", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="complaintsPercent"
                  value={stepData.complaintsPercent || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showAvailable && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Is it available in the right location? (Physical/Digital)
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.available === "+Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setAvailable("+Yes");
                      updateStepData(activeStep, "available", "+Yes");
                      localStorage.setItem("available", "+Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.available === "+No" ? "selected" : ""}`}
                    onClick={() => {
                      setAvailable("+No");
                      updateStepData(activeStep, "available", "+No");
                      localStorage.setItem("available", "+No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="available"
                  value={stepData.available || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      case 9: {
        const showLegal = !!stepData.adopt20 || !!revealedFields[9]?.legal;
        const showMarketing = (showLegal && !!stepData.legal) || !!revealedFields[9]?.marketing;
        const showInvestorFit = (showMarketing && !!stepData.marketing) || !!revealedFields[9]?.investorFit;
        const showIdea = (showInvestorFit && !!stepData.investorFit) || !!revealedFields[9]?.idea;

        return (
          <>
            <div className="input-group query-fade-in">
              <label style={{ display: 'block', marginBottom: '8px' }}>
                Are you able to adopt 20 mindsets about entrepreneurship in the
                future?
              </label>
              <div className="options-btn-row">
                <button
                  type="button"
                  className={`option-btn ${stepData.adopt20 === "|Yes" ? "selected" : ""}`}
                  onClick={() => {
                    setAdopt20("|Yes");
                    updateStepData(activeStep, "adopt20", "|Yes");
                    localStorage.setItem("adopt20", "|Yes");
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className={`option-btn ${stepData.adopt20 === "|No" ? "selected" : ""}`}
                  onClick={() => {
                    setAdopt20("|No");
                    updateStepData(activeStep, "adopt20", "|No");
                    localStorage.setItem("adopt20", "|No");
                  }}
                >
                  No
                </button>
              </div>
              <input
                type="text"
                name="adopt20"
                value={stepData.adopt20 || ""}
                style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                required
                readOnly
              />
            </div>

            {showLegal && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Does the product/service align with legal or user preferences?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.legal === "}Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setLegal("}Yes");
                      updateStepData(activeStep, "legal", "}Yes");
                      localStorage.setItem("legal", "}Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.legal === "}No" ? "selected" : ""}`}
                    onClick={() => {
                      setLegal("}No");
                      updateStepData(activeStep, "legal", "}No");
                      localStorage.setItem("legal", "}No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="legal"
                  value={stepData.legal || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showMarketing && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>Do you have product/service marketing problem?</label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.marketing === ":Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setMarket(":Yes");
                      updateStepData(activeStep, "marketing", ":Yes");
                      localStorage.setItem("marketing", ":Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.marketing === ":No" ? "selected" : ""}`}
                    onClick={() => {
                      setMarket(":No");
                      updateStepData(activeStep, "marketing", ":No");
                      localStorage.setItem("marketing", ":No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="marketing"
                  value={stepData.marketing || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showInvestorFit && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  For investors: Does your startup idea fit their thesis/mandate?
                </label>
                <div className="options-btn-row">
                  {["stage", "impact"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.investorFit === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "investorFit", opt);
                        localStorage.setItem("investorFit", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="investorFit"
                  value={stepData.investorFit || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showIdea && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Are you able to adopt the problem statement and would you stick
                  to that kind of idea in the long run? Do you believe in this
                  idea?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.idea === "{Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setIdea("{Yes");
                      updateStepData(activeStep, "idea", "{Yes");
                      localStorage.setItem("idea", "{Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.idea === "{No" ? "selected" : ""}`}
                    onClick={() => {
                      setIdea("{No");
                      updateStepData(activeStep, "idea", "{No");
                      localStorage.setItem("idea", "{No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="idea"
                  value={stepData.idea || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      case 10: {
        const showArea = (!!stepData.city?.trim() && !!stepData.stateName?.trim()) || !!revealedFields[10]?.area;
        const showCollaborationOrg = (showArea && stepData.area === "<Yes") || !!revealedFields[10]?.collaborationOrg;
        const showCoe = (showArea && (stepData.area === "<No" || (stepData.area === "<Yes" && !!stepData.collaborationOrg))) || !!revealedFields[10]?.coe;

        return (
          <>
            <div className="input-group query-fade-in">
              <label style={{ display: 'block', marginBottom: '8px' }}>
                Where do you want to register your company address / open your
                headquarters?
              </label>
              <input
                type="text"
                name="city"
                placeholder="City/District"
                value={stepData.city || ""}
                onChange={(e) => {
                  setCity(e.target.value);
                  updateStepData(index, "city", e.target.value);
                }}
                required
              />
              <br />
              <input
                type="text"
                name="stateName"
                placeholder="State"
                value={stepData.stateName || ""}
                onChange={(e) => {
                  setStateName(e.target.value);
                  updateStepData(index, "stateName", e.target.value);
                }}
                required
              />
            </div>

            {showArea && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Do you have information about your idea-related / sector-related
                  incubation centre in your area?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.area === "<Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setArea("<Yes");
                      updateStepData(activeStep, "area", "<Yes");
                      localStorage.setItem("area", "<Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.area === "<No" ? "selected" : ""}`}
                    onClick={() => {
                      setArea("<No");
                      updateStepData(activeStep, "area", "<No");
                      localStorage.setItem("area", "<No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="area"
                  value={stepData.area || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}

            {showCollaborationOrg && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  If yes, which organization do you collaborate with on your
                  mission-driven projects?
                </label>
                <div className="options-btn-row">
                  {["Academia", "Corporate", "Government", "PPP"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      className={`option-btn ${stepData.collaborationOrg === opt ? "selected" : ""}`}
                      onClick={() => {
                        updateStepData(activeStep, "collaborationOrg", opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                <input
                  type="text"
                  name="collaborationOrg"
                  value={stepData.collaborationOrg || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required={stepData.area === "<Yes"}
                  readOnly
                />
              </div>
            )}

            {showCoe && (
              <div className="input-group query-fade-in">
                <label style={{ display: 'block', marginBottom: '8px' }}>
                  Does your city/state have a prototype-related manufacturing /
                  Advanced Technology CoE?
                </label>
                <div className="options-btn-row">
                  <button
                    type="button"
                    className={`option-btn ${stepData.coe === ">Yes" ? "selected" : ""}`}
                    onClick={() => {
                      setCoe(">Yes");
                      updateStepData(activeStep, "coe", ">Yes");
                      localStorage.setItem("coe", ">Yes");
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={`option-btn ${stepData.coe === ">No" ? "selected" : ""}`}
                    onClick={() => {
                      setCoe(">No");
                      updateStepData(activeStep, "coe", ">No");
                      localStorage.setItem("coe", ">No");
                    }}
                  >
                    No
                  </button>
                </div>
                <input
                  type="text"
                  name="coe"
                  value={stepData.coe || ""}
                  style={{ position: 'absolute', opacity: 0.01, zIndex: -1, width: '1px', height: '1px', pointerEvents: 'none' }}
                  required
                  readOnly
                />
              </div>
            )}
          </>
        );
      }

      default:
        return <p>No form fields for this step yet.</p>;
    }
  };

  return (
    <div className={`idea-validation-wrapper ${activeTheme === "dark" ? "dark-mode" : ""}`}>

     

      {submitted ? (
        <></>
      ) : (
        <div className="card1">
            <div className="idea-val-header">
      <h1>IDEA VALIDATION TEST(FORM)</h1>
      <div className="sample-idea-group">
        <span className="sample-idea-label">Sample</span>
        <div className="sample-idea-btns">
          <button className="sample-idea-btn sample-idea-strong" onClick={() => prefillForm("strong")}>
            💡 Strong Idea
          </button>
          <button className="sample-idea-btn sample-idea-weak" onClick={() => prefillForm("weak")}>
            ⚠️ Weak Idea
          </button>
        </div>
      </div>
      </div>
          {/* ---------------- STEP INDICATOR ---------------- */}
          <div className="stepper-container">
            {steps.map((label, index) => (
              <div
                key={index}
                className={`step ${index === activeStep || index < activeStep ? "active" : ""}`}
                onClick={() => setActiveStep(index)}
                title={label}
              >
                <div className="circle">
                  {index < activeStep ? "✓" : stepIcons[index]}
                </div>
                {index !== steps.length - 1 && (
                  <div className={`line ${index < activeStep ? "active" : ""}`}></div>
                )}
                <div className="step-label">{label}</div>
              </div>
            ))}
          </div>

          {/* ✅ MindMap-style back button — absolute top-left inside card */}
          {!isSubmitting && (
            <div className="mindmap-heading-row">
              <button
                type="button"
                className="mindmap-back-btn"
                onClick={() => {
                  if (activeStep === 0) {
                    setToggle(false);
                    onClose();
                    navigate("/dashboard");
                  } else {
                    handleBackStep();
                  }
                }}
                aria-label={activeStep === 0 ? "Close form" : "Go to previous step"}
              >
                <FaArrowLeftLong />
              </button>
            </div>
          )}

          {/* ✕ Clear / Close button — absolute top-right inside card */}
          {!isSubmitting && (() => {
            const isFormEmpty = Object.values(formData).every(
              (step) => !step || Object.values(step).every((v) => !v || v === "")
            );
            return (
              <div className="mindmap-clear-row">
                <button
                  type="button"
                  className="mindmap-clear-btn"
                  title={isFormEmpty ? "Close" : "Clear all entered data"}
                  aria-label={isFormEmpty ? "Close form" : "Clear all data"}
                  onClick={() => {
                    if (isFormEmpty) {
                      setToggle(false);
                      onClose();
                      navigate("/dashboard");
                    } else {
                      clearForm();
                    }
                  }}
                >
                  ✕
                </button>
              </div>
            );
          })()}

          {/* ---------------- FORM BODY ---------------- */}
          <div className="form">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeStep}
                initial={prefersReducedMotion ? false : { opacity: 0, x: 24 }}
                animate={{ opacity: 1, x: 0 }}
                exit={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, x: -24 }}
                transition={{ duration: 0.28, ease: "easeOut" }}
                style={{ width: "100%" }}
              >
                {renderStepForm(activeStep)}
              </motion.div>
            </AnimatePresence>
          </div>

          {/* ---------------- BUTTONS ---------------- */}
          <div className="form-buttons">

            {/* Next / Submit buttons at right */}
            <div className="right-buttons">
              {submitError && (
                <div style={{ color: "#EF4444", fontSize: "13px", marginBottom: 8, padding: "8px 12px", background: "rgba(239,68,68,0.08)", borderRadius: 8, border: "1px solid rgba(239,68,68,0.2)" }}>
                  ⚠️ {submitError}
                </div>
              )}
              {activeStep === steps.length - 1 ? (
                <button
                  className="submit"
                  disabled={isSubmitting}
                  onClick={() => requireAuth(async () => {
                    const form = document.querySelector(".form");
                    if (!form) return;

                    // ✅ Validate all required fields using native HTML5 API
                    const inputs = form.querySelectorAll(
                      "input[required], select[required], textarea[required]"
                    );

                    let allValid = true;

                    for (const input of inputs) {
                      if (!input.checkValidity()) {
                        input.reportValidity();
                        allValid = false;
                        break;
                      }
                    }

                    if (!allValid) return;

                    // ✅ Collect CURRENT (last) step fields from DOM
                    const elements = form.querySelectorAll("input, select, textarea");
                    const currentStepData = {};

                    elements.forEach((el) => {
                      const { name, type } = el;
                      if (!name) return;

                      if (type === "radio") {
                        if (el.checked) {
                          currentStepData[name] = el.value;
                        }
                      } else {
                        currentStepData[name] = el.value;
                      }
                    });

                    // ✅ Ensure all previous steps have saved data
                    for (let i = 0; i < steps.length; i++) {
                      if (i === activeStep) continue;
                      const saved = formData[i];
                      if (!saved || Object.keys(saved).length === 0) {
                        setActiveStep(i);
                        setMissingStepIndex(i);
                        setShowMissingFieldsPopup(true);
                        return;
                      }
                    }

                    // ✅ Merge all steps
                    const allFields = {};
                    Object.values(formData).forEach((stepObj) => {
                      if (stepObj && typeof stepObj === "object") {
                        Object.assign(allFields, stepObj);
                      }
                    });

                    Object.assign(allFields, currentStepData);

                    const finalSector = formData[1]?.sector || currentStepData.sector || "";
                    localStorage.setItem("sector", finalSector);

                    const userId = user?.user_id;
                    const payload = {
                      userId,
                      ...allFields,
                      linkedinVerified:  linkStatus.linkedin     === true,
                      websiteVerified:   linkStatus.website      === true,
                      emailVerified:     linkStatus.companyEmail === true,
                      isSampleIdea,
                    };

                    try {
                      setIsSubmitting(true);
                      setSubmitError("");
                      const res = await apiFetch(`/idea-validation/store-form`, {
                        method: "POST",
                        body: JSON.stringify(payload),
                      });

                      if (!res.ok) {
                        const errData = await res.json().catch(() => ({}));
                        const msg = errData?.error?.message || errData?.error || `Server error (${res.status}). Please try again.`;
                        setSubmitError(typeof msg === "string" ? msg : "Submission failed. Please try again.");
                        return;
                      }

                      const data = await res.json();

                      if (!data?.success) {
                        const msg = data?.error?.message || data?.error || "Submission failed. Please try again.";
                        setSubmitError(typeof msg === "string" ? msg : "Submission failed. Please try again.");
                        return;
                      }

                      // ✅ Use backend-calculated score as single source of truth (0–600)
                      const backendScore = data?.totalScore ?? 0;
                      setScore(backendScore);

                      localStorage.setItem("scorecardData", JSON.stringify(data));
                      setReportData(data);
                      const tokenA = crypto.randomUUID() + crypto.randomUUID();
                      const tokenB = crypto.randomUUID() + crypto.randomUUID();
                      localStorage.setItem("reportPartA", tokenA);
                      localStorage.setItem("reportPartB", tokenB);
                      const recordId = data.recordId || data.data?.recordId;
                      if (recordId) {
                        localStorage.setItem("ideaValidationPaymentRecordId", recordId);
                        localStorage.setItem("payingReportId", recordId);
                        localStorage.setItem("payingReportType", "A");
                      }

                      setSubmitted(true);
                    } catch (err) {
                      console.error("Error submitting form:", err);
                      setSubmitError("Network error. Check your connection and try again.");
                    } finally {
                      setIsSubmitting(false);
                    }
                  })}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              ) : (
                ([0, 1, 2].includes(activeStep) || activeStep < maxReachedStep) ? (
                <button
                  type="button"
                  className="save-next"
                  onClick={(e) => {
                    e.preventDefault();
                    const form = document.querySelector(".form");
                    if (!form) return;

                    const inputs = form.querySelectorAll(
                      "input[required], select[required], textarea[required]"
                    );

                    let allValid = true;

                    inputs.forEach((input) => {
                      if (!allValid) return;
                      if (!input.checkValidity()) {
                        input.reportValidity();
                        allValid = false;
                      }
                    });

                    if (!allValid) return;

                    if (activeStep === 0) {
                      const currentStep0Data = formData[0] || {};
                      const requiredFields = ["companyName", "fullName", "contact", "linkedin", "companyEmail", "ideaYears", "teamSize"];
                      for (const field of requiredFields) {
                        const val = currentStep0Data[field];
                        if (!val || (typeof val === "string" && !val.trim())) {
                          const input = form.querySelector(`[name="${field}"]`);
                          if (input) {
                            input.reportValidity();
                          }
                          return;
                        }
                      }

                      const contact = currentStep0Data.contact || "";
                      if (!/^[6-9]\d{9}$/.test(contact)) {
                        setErrors((prev) => ({
                          ...prev,
                          contact: "Please enter a valid 10-digit Indian mobile number",
                        }));
                        const contactInput = form.querySelector('input[name="contact"]');
                        contactInput?.focus();
                        return;
                      }
                    }

                    const elements = form.querySelectorAll("input, select, textarea");
                    const stepData = {};

                    elements.forEach((el) => {
                      const { name, type } = el;
                      if (!name) return;

                      if (type === "radio") {
                        if (el.checked) {
                          stepData[name] = el.value;
                        }
                      } else {
                        stepData[name] = el.value;
                      }
                    });

                    setFormData((prev) => ({
                      ...prev,
                      [activeStep]: stepData,
                    }));

                    setActiveStep(activeStep < steps.length - 1 ? activeStep + 1 : activeStep);
                  }}
                >
                  Next
                </button>
                ) : null
              )}
            </div>
          </div>
        </div>
      )}
      {showMissingFieldsPopup && (
        <div className="missing-popup-overlay">
          <div className="missing-popup-card">
            <h3>Please Enter all the fields ?</h3>
            <div className="missing-popup-actions">
              <button
                className="missing-ok"
                onClick={() => setShowMissingFieldsPopup(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
